<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnDeductionsSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Goodwill')"
                         :calculated-value="data.calculated.statement_transactions_goodwill"
                         v-model="data.edit.statement_transactions_goodwill"/>

      <TaxReturnTableRow :description="$gettext('Overige immateriele vaste activa')"
                         :calculated-value="data.calculated.statement_transactions_immaterial_activa"
                         v-model="data.edit.statement_transactions_immaterial_activa"/>

       <TaxReturnTableRow :description="$gettext('Gebouwen en terreinen')"
                         :calculated-value="data.calculated.statement_transactions_real_estate"
                         v-model="data.edit.statement_transactions_real_estate"/>

      <TaxReturnTableRow :description="$gettext('Machines en installaties')"
                         :calculated-value="data.calculated.statement_transactions_machines"
                         v-model="data.edit.statement_transactions_machines"/>

      <TaxReturnTableRow :description="$gettext('Overige materiele vaste activa')"
                         :calculated-value="data.calculated.statement_transactions_material_activa"
                         v-model="data.edit.statement_transactions_material_activa"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>